module.exports = __webpack_public_path__ + "static/media/barrier-article.9a399584.jpeg";